export default "__VITE_ASSET__Die2qwde__"